import React, { useMemo } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import RewardLevel from '../pages/CategoryManagement/RewardLevel';
import Country from '../pages/CategoryManagement/Country';
import Language from '../pages/CategoryManagement/Language';
import EducationLevel from '../pages/CategoryManagement/EducationLevel';
import ResearchField from '../pages/CategoryManagement/ResearchField';
import RewardType from '../pages/CategoryManagement/RewardType';
import JobTitle from '../pages/CategoryManagement/JobTitle';
import ProjectType from '../pages/CategoryManagement/ProjectType';
import TopicLevel from '../pages/CategoryManagement/TopicLevel';
import OtherResearchContent from '../pages/CategoryManagement/OtherResearchContent';
import JournalType from '../pages/CategoryManagement/JournalType';
import StandardHour from '../pages/CategoryManagement/StandardHour';
import ResearchReduction from '../pages/CategoryManagement/ResearchReduction';
import TeachingMajor from '../pages/CategoryManagement/TeachingMajor';
import User from '../pages/UserManagement/User';
import Department from '../pages/UserManagement/Department';
import UserStandardHour from '../pages/Scoring/UserStandardHour';
import UserResearchReduction from '../pages/Scoring/UserResearchReduction';
import ScienceScoring from '../pages/Scoring/ScienceScoring';
import StudentResearch from '../pages/Register/StudentResearch';
import ConferenceRegistration from '../pages/Register/ConferenceRegistration';
import BookCompilation from '../pages/Register/BookCompilation';
import TopicProposal from '../pages/Register/TopicProposal';
import ArticleReward from '../pages/Register/ArticleReward';
import Journal from '../pages/ScientificManagement/Journal';
import HourReductionDeclaration from '../pages/ScientificManagement/HourReductionDeclaration';
import StandardHourDeclaration from '../pages/ScientificManagement/StandardHourDeclaration';
import OtherScienceDeclaration from '../pages/ScientificManagement/OtherScienceDeclaration';
import BookPublication from '../pages/ScientificManagement/BookPublication';
import ScientificTopic from '../pages/ScientificManagement/ScientificTopic';
import ScientificArticlesMngt from '../pages/ScientificManagement/ScientificArticlesMngt';
import ScienceScoringManagement from '../pages/ScientificManagement/ScienceScoringManagement';
import ScientificProject from '../pages/ScientificPublications/ScientificProject';
import PublicationBook from '../pages/ScientificPublications/PublicationBook';
import PublicationOther from '../pages/ScientificPublications/PublicationOther';
import ScientificArticle from '../pages/ScientificPublications/ScientificArticle';
import TopicProposalManagement from '../pages/RegisterManagement/TopicProposalManagement';
import BookCompilationManagement from '../pages/RegisterManagement/BookCompilationManagement';
import ConferenceRegistrationManagement from '../pages/RegisterManagement/ConferenceRegistrationManagement';
import StudentResearchManagement from '../pages/RegisterManagement/StudentResearchManagement';
import ArticleRewardManagement from '../pages/RegisterManagement/ArticleRewardManagement';
import ContactInformation from '../pages/Profile/ContactInformation';
import WorkHistory from '../pages/Profile/WorkHistory';
import EducationHistory from '../pages/Profile/EducationHistory';
import ProfileResearchField from '../pages/Profile/ProfileResearchField';
import ProfileTeachingMajor from '../pages/Profile/ProfileTeachingMajor';
import ProfileAcademicTitle from '../pages/Profile/ProfileAcademicTitle';
import ProfileForeignLanguage from '../pages/Profile/ProfileForeignLanguage';
import ProfileAward from '../pages/Profile/ProfileAward';
import ProfileMentoring from '../pages/Profile/ProfileMentoring';
import ScientificCV from '../pages/Profile/ScientificCV';
import ActivityHistory from '../pages/Profile/ActivityHistory';
import Initiative from '../pages/Initiative/Initiative';
import InitiativeManagement from '../pages/InitiativeManagement/InitiativeManagement';
import HRStatistics from '../pages/Statistical/HRStatistics';
import ArticleStatsByLecturer from '../pages/Statistical/ArticleStatsByLecturer';
import LecturerArticleDetails from '../pages/Statistical/LecturerArticleDetails';
import ArticleStatsByDepartment from '../pages/Statistical/ArticleStatsByDepartment';
import ProposalStatsByDepartment from '../pages/Statistical/ProposalStatsByDepartment';
import ArticleStatsByType from '../pages/Statistical/ArticleStatsByType';
import ProposalStatsByIndividual from '../pages/Statistical/ProposalStatsByIndividual';
import Dashboard from '../pages/Dashboard';
import ScoringConfiguration from '../pages/ScientificManagement/ScoringConfiguration';
import ScienceScoringNew from '../pages/Scoring/ScienceScoringNew';
import SyncToTdkt from '../pages/TDKT/SyncToTdkt';
import PublicDashboard from '../pages/PublicDashboard/PublicDashboard';
import PublicScientificTopic from '../pages/PublicDashboard/PublicScientificTopic';
import PublicBookPublication from '../pages/PublicDashboard/PublicBookPublication';
import PublicOtherScienceDeclaration from '../pages/PublicDashboard/PublicOtherScienceDeclaration';
import PublicScientificArticle from '../pages/PublicDashboard/PublicScientificArticle';

const ProtectedRoute = ({ children, allowed }) => {
    if (!allowed) {
        return <Navigate to="/thong-tin-lien-he" replace />;
    }
    return children;
};

const AppRoutes = ({ triggerNotification }) => {
    const currentUser = useMemo(() => JSON.parse(localStorage.getItem('user')) || {}, []);

    const { isSystemAdmin, isScientificManager } = useMemo(() => {
        const roleName = (currentUser?.RoleName || '').toLowerCase();
        const roleId = currentUser?.RoleId;
        const isDel = currentUser?.IsDelegatedAdmin === true;
        const sysAdmin = roleId === 1 || roleName === 'quản trị viên';
        const sciManager = sysAdmin || roleId === 11 || roleName.includes('quản lý khoa');

        return { isSystemAdmin: sysAdmin, isScientificManager: sciManager };
    }, [currentUser]);

    return (
        <Routes>
            <Route path="/thong-tin-lien-he" element={<ContactInformation />} />
            <Route path="/qua-trinh-cong-tac" element={<WorkHistory />} />
            <Route path="/qua-trinh-dao-tao" element={<EducationHistory />} />
            <Route path="/linh-vuc-nghien-cuu-ca-nhan" element={<ProfileResearchField />} />
            <Route path="/chuyen-nganh-giang-day-ca-nhan" element={<ProfileTeachingMajor />} />
            <Route path="/hoc-vi-chuc-danh" element={<ProfileAcademicTitle />} />
            <Route path="/ngoai-ngu-ca-nhan" element={<ProfileForeignLanguage />} />
            <Route path="/danh-hieu-giai-thuong" element={<ProfileAward />} />
            <Route path="/huong-dan-sau-dai-hoc" element={<ProfileMentoring />} />
            <Route path="/ly-lich-khoa-hoc" element={<ScientificCV />} />
            <Route path="/lich-su-hoat-dong" element={<ActivityHistory />} />
            <Route path="/bai-bao-tham-luan" element={<ScientificArticle onActionSuccess={triggerNotification} />} />
            <Route path="/de-tai" element={<ScientificProject onActionSuccess={triggerNotification} />} />
            <Route path="/sach-giao-trinh" element={<PublicationBook />} />
            <Route path="/NCKH-khac" element={<PublicationOther />} />
            <Route path="/danh-sach-sang-kien" element={<Initiative />} />
            <Route path="/sinh-vien-nckh" element={<StudentResearch />} />
            <Route path="/dang-ky-tham-du-hoi-nghi" element={<ConferenceRegistration />} />
            <Route path="/dang-ky-bien-soan" element={<BookCompilation />} />
            <Route path="/de-xuat-de-tai" element={<TopicProposal />} />
            <Route path="/ho-tro-cong-bo-khoa-hoc" element={<ArticleReward />} />
            <Route path="/gio-dinh-muc" element={<UserStandardHour />} />
            <Route path="/ke-khai-giam-gio-dinh-muc" element={<UserResearchReduction />} />
            <Route path="/tinh-diem-backup" element={<ScienceScoring />} />
            <Route path="/tinh-diem" element={<ScienceScoringNew />} />

            <Route path="/public-dashboard" element={<PublicDashboard />} />
            <Route path="/public-de-tai" element={<PublicScientificTopic />} />
            <Route path="/public-sach-giao-trinh" element={<PublicBookPublication />} />
            <Route path="/public-nckh-khac" element={<PublicOtherScienceDeclaration />} />
            <Route path="/public-bai-bao" element={<PublicScientificArticle />} />

            <Route path="/" element={
                isScientificManager ? <Dashboard /> : <Navigate to="/thong-tin-lien-he" replace />
            } />
            <Route path="/quan-ly-bai-bao" element={
                <ProtectedRoute allowed={isScientificManager}><ScientificArticlesMngt /></ProtectedRoute>
            } />
            <Route path="/quan-ly-tap-chi" element={
                <ProtectedRoute allowed={isScientificManager}><Journal /></ProtectedRoute>
            } />
            <Route path="/quan-ly-ke-khai-giam-gio" element={
                <ProtectedRoute allowed={isScientificManager}><HourReductionDeclaration /></ProtectedRoute>
            } />
            <Route path="/quan-ly-gio-dinh-muc" element={
                <ProtectedRoute allowed={isScientificManager}><StandardHourDeclaration /></ProtectedRoute>
            } />
            <Route path="/quan-ly-noi-dung-NCKH-khac" element={
                <ProtectedRoute allowed={isScientificManager}><OtherScienceDeclaration /></ProtectedRoute>
            } />
            <Route path="/quan-ly-sach-giao-trinh" element={
                <ProtectedRoute allowed={isScientificManager}><BookPublication /></ProtectedRoute>
            } />
            <Route path="/quan-ly-de-tai" element={
                <ProtectedRoute allowed={isScientificManager}><ScientificTopic /></ProtectedRoute>
            } />
            <Route path="/quan-ly-de-xuat-de-tai" element={
                <ProtectedRoute allowed={isScientificManager}><TopicProposalManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-dang-ky-bien-soan" element={
                <ProtectedRoute allowed={isScientificManager}><BookCompilationManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-dang-ky-tham-du-hoi-nghi" element={
                <ProtectedRoute allowed={isScientificManager}><ConferenceRegistrationManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-sinh-vien-nckh" element={
                <ProtectedRoute allowed={isScientificManager}><StudentResearchManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-ho-tro-cong-bo-khoa-hoc" element={
                <ProtectedRoute allowed={isScientificManager}><ArticleRewardManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-diem" element={
                <ProtectedRoute allowed={isScientificManager}><ScienceScoringManagement /></ProtectedRoute>
            } />
            <Route path="/quan-ly-co-che-tinh-diem" element={
                <ProtectedRoute allowed={isSystemAdmin}><ScoringConfiguration /></ProtectedRoute>
            } />
            <Route path="/quan-ly-sang-kien" element={
                <ProtectedRoute allowed={isScientificManager}><InitiativeManagement /></ProtectedRoute>
            } />
            <Route path="/thong-ke-nhan-luc" element={
                <ProtectedRoute allowed={isScientificManager}><HRStatistics /></ProtectedRoute>
            } />
            <Route path="/thong-ke-bai-bao-giang-vien" element={
                <ProtectedRoute allowed={isScientificManager}><ArticleStatsByLecturer /></ProtectedRoute>
            } />
            <Route path="/thong-ke-bai-bao/chi-tiet" element={
                <ProtectedRoute allowed={isScientificManager}><LecturerArticleDetails /></ProtectedRoute>
            } />
            <Route path="/thong-ke-bai-bao-loai" element={
                <ProtectedRoute allowed={isScientificManager}><ArticleStatsByType /></ProtectedRoute>
            } />
            <Route path="/thong-ke-bai-bao-don-vi" element={
                <ProtectedRoute allowed={isScientificManager}><ArticleStatsByDepartment /></ProtectedRoute>
            } />
            <Route path="/thong-ke-de-xuat-don-vi" element={
                <ProtectedRoute allowed={isScientificManager}><ProposalStatsByDepartment /></ProtectedRoute>
            } />
            <Route path="/thong-ke-de-xuat-ca-nhan" element={
                <ProtectedRoute allowed={isScientificManager}><ProposalStatsByIndividual /></ProtectedRoute>
            } />
            <Route path="/nguoi-dung" element={
                <ProtectedRoute allowed={isSystemAdmin}><User /></ProtectedRoute>
            } />
            <Route path="/co-cau-to-chuc" element={
                <ProtectedRoute allowed={isSystemAdmin}><Department /></ProtectedRoute>
            } />
            <Route path="/cap-khen-thuong" element={
                <ProtectedRoute allowed={isSystemAdmin}><RewardLevel /></ProtectedRoute>
            } />
            <Route path="/quoc-gia" element={
                <ProtectedRoute allowed={isSystemAdmin}><Country /></ProtectedRoute>
            } />
            <Route path="/ngoai-ngu" element={
                <ProtectedRoute allowed={isSystemAdmin}><Language /></ProtectedRoute>
            } />
            <Route path="/trinh-do" element={
                <ProtectedRoute allowed={isSystemAdmin}><EducationLevel /></ProtectedRoute>
            } />
            <Route path="/linh-vuc-nghien-cuu" element={
                <ProtectedRoute allowed={isSystemAdmin}><ResearchField /></ProtectedRoute>
            } />
            <Route path="/loai-khen-thuong" element={
                <ProtectedRoute allowed={isSystemAdmin}><RewardType /></ProtectedRoute>
            } />
            <Route path="/chuc-danh" element={
                <ProtectedRoute allowed={isSystemAdmin}><JobTitle /></ProtectedRoute>
            } />
            <Route path="/loai-cong-trinh" element={
                <ProtectedRoute allowed={isSystemAdmin}><ProjectType /></ProtectedRoute>
            } />
            <Route path="/cap-de-tai" element={
                <ProtectedRoute allowed={isSystemAdmin}><TopicLevel /></ProtectedRoute>
            } />
            <Route path="/noi-dung-NCKH-khac" element={
                <ProtectedRoute allowed={isSystemAdmin}><OtherResearchContent /></ProtectedRoute>
            } />
            <Route path="/loai-tap-chi" element={
                <ProtectedRoute allowed={isSystemAdmin}><JournalType /></ProtectedRoute>
            } />
            <Route path="/gio-chuan" element={
                <ProtectedRoute allowed={isSystemAdmin}><StandardHour /></ProtectedRoute>
            } />
            <Route path="/giam-tru-nckh" element={
                <ProtectedRoute allowed={isSystemAdmin}><ResearchReduction /></ProtectedRoute>
            } />
            <Route path="/chuyen-nganh-giang-day" element={
                <ProtectedRoute allowed={isSystemAdmin}><TeachingMajor /></ProtectedRoute>
            } />

            <Route path="/dong-bo-tdkt" element={
                <ProtectedRoute allowed={isSystemAdmin}><SyncToTdkt /></ProtectedRoute>
            } />
        </Routes>
    );
};

export default AppRoutes;